import footerLogo from './js/widgets/footerLogo.js';
import footerBackground from './js/widgets/footerBackground.js';
import sponsors from './js/widgets/sponsors.js';
import customFeatureLineUp from './js/helpers/featureLineUp.js';


import mainFeatureSlide from './js/widgets/mainFeatureSlide.js';
import seoBlock from './js/widgets/seoBlock.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import moreCardsWidget from './js/widgets/moreCardsWidget.js';

import './js/localjs.js';


$(document).ready(function () {
  customFeatureLineUp();
  footerBackground();
  footerLogo();

  if (window.location.pathname === '/') {
    mainFeatureSlide();
    seoBlock();
    multiScheduleFeature();
    moreCardsWidget();
    sponsors();
  }

});